import { Component, Inject, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { addressI } from 'app/core/interfaces/adress';
import { DialogData } from 'app/core/interfaces/dialog';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';

@Component({
  selector: 'page-procedure-details',
  templateUrl: './procedure-details.component.html',
  styleUrls: ['./procedure-details.component.scss'],
})
export class ProcedureDetailsComponent extends BaseComponent implements OnInit {
  public procedure: Healthcareservice = <Healthcareservice>{};
  public address: addressI = <addressI>{};
  public active = true;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private healthcareService: ProcedureService,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getProcedureDetails();

    if (!this.procedure) {
      this.dialogRef.close();
    }
  }

  textLineBreak(text: any) {
    if (text) {
      return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
    return '';
  }

  getProcedureDetails() {
    if (this.data.param.procedure) {
      this.procedure = this.data.param.procedure;
      this.active = this.procedure?.status!;
    } else {
      this.showAlertAndClose();
    }
  }

  getProcedurePaymentText() {
    let text = 'Valor do Exame: R$ ';

    if (this.procedure?.price_high) {
      text += this.procedure?.price_high;
    }

    return  text;
  }

  showAlertAndClose() {
    const alert: any = this.layout.openDialog({ title: 'Aviso', content: 'Exame não encontrado!', showButtonCancel: false });
    alert.then(
      () => {
        this.dialogRef.close();
      },
      () => {
        this.dialogRef.close();
      }
    );
  }

  changeStatus() {
    if (this.procedure) {
      const id = this.procedure?.healthcareservice_id;
      this.procedure.status = this.active;

      this.healthcareService.update(id!, this.procedure).subscribe({
        next: (restHealthcare) => {
          this.showSuccessMessage = true;
        },

        error: (err) => {
          this.showErrorMessage = true;
        },
      });
    }
  }

  public remove() {
    if (this.procedure) {
      this.layout
        .openDialog({
          showButtonCancel: true,
          buttonText: 'Remover',
          title: 'Deseja remover o exame?',
          content: 'Certifique-se de que o exame não esteja vinculado a uma consulta.',
        })
        .subscribe((retorno: any) => {
          if (retorno) {
            this.removeProcedure();
          }
        });
    }
  }

  /**
   * Esse método invocava a função checkUsage() para verificar se o exame já estabela atrelado a um agendamento.
   * Por enquanto tirei essa verificação, pois ainda não temos isso no backend
   */
  public removeProcedure() {
    const id = this.procedure?.healthcareservice_id;

    this.healthcareService.deleteProcedure(id!).subscribe({
      next: (res) => {
        this.layout.openDialog({
          showButtonCancel: false,
          buttonText: 'Ok',
          title: 'Sucesso',
          content: 'Exame excluído com sucesso!',
        });

        this.dialogRef.close();
        location.reload();
      },
      error: (err) => {
        this.layout.openDialog({
          showButtonCancel: false,
          buttonText: 'Ok',
          title: 'Não é possível remover',
          content: 'Esse exame já está vinculado a uma consulta.',
        });
      },
    });
  }

  openProcedureFormEdit() {
    this.dialog.openProcedureFormDialog({
      component: 'procedure-form',
      param: { procedure: this.procedure, mode: 'UPDATE' },
    });
  }

  openProcedureForm() {
    this.dialog.openProcedureFormDialog({
      component: 'procedure-form',
      param: {},
    });
  }
}
